module.exports = __webpack_public_path__ + "img/box9-18.8883611f.png";